export const DEVICE_TYPE = 1;

export const gstCalculator = (amount, percent) => {
    const gst = (amount * percent) / 100;
    return amount + gst;
};
